import RedeemModule from './components/RedeemPage/RedeemPage';
import redeemReducer from './store/redeem.reducer';
import { redeemEpics } from './store/redeem.epics';

export { redeemReducer, redeemEpics };

export default RedeemModule;
